import { defineMessages } from 'react-intl';

export default defineMessages({
    yourCoverage: {
        id: 'ml.quoteandbind.paeditcoverages.yourCoverage',
        defaultMessage: 'Your coverage'
    },
    yourVehicleCoverage: {
        id: 'ml.quoteandbind.paeditcoverages.yourVehicleCoverage',
        defaultMessage: 'Your vehicle coverage'
    },
    snapshotMsg: {
        id: 'ml.quoteandbind.paeditcoverages.snapshotMsg',
        defaultMessage: 'This is a snapshot of coverages, limits and premium for your vehicles. Coverage can be customized'
    },
    addVehicle: {
        id: 'ml.quoteandbind.paeditcoverages.addVehicle',
        defaultMessage: 'ADD VEHICLE'
    },
    editCoverage: {
        id: 'ml.quoteandbind.paeditcoverages.editCoverage',
        defaultMessage: 'EDIT COVERAGE'
    },
    coverageTotal: {
        id: 'ml.quoteandbind.paeditcoverages.coverageTotal',
        defaultMessage: 'Coverage Total'
    },
    vehicleTotal: {
        id: 'ml.quoteandbind.paeditcoverages.vehicleTotal',
        defaultMessage: 'Vehicle Total'
    },
    premiumTooltipLabel: {
        id: 'ml.quoteandbind.paeditcoverages.premiumTooltipLabel',
        defaultMessage: 'What is not included in this premium?'
    },
    tooltipPremiumNoTaxes: {
        id: 'ml.quoteandbind.paeditcoverages.tooltipPremiumNoTaxes',
        defaultMessage: 'The premium shown does not include fees or taxes.'
    },
    includedPremium: {
        id: 'ml.quoteandbind.paeditcoverages.includedPremium',
        defaultMessage: 'What is not included in this premium?'
    },
    exclusion: {
        id: 'ml.quoteandbind.paeditcoverages.exclusion',
        defaultMessage: 'Exclusion'
    },
    termTypeAnnual: {
        id: 'ml.quoteandbind.paeditcoverages.termTypeAnnual',
        defaultMessage: 'Annual policy term'
    },
    termType6Month: {
        id: 'ml.quoteandbind.paeditcoverages.termType6Month',
        defaultMessage: '6 month policy term'
    },
    termType7day: {
        id: 'ml.quoteandbind.paeditcoverages.termType7day',
        defaultMessage: '7 day policy term'
    },
    remove: {
        id: 'ml.quoteandbind.paeditcoverages.remove',
        defaultMessage: 'Remove'
    },
    pickYourCoverageLevel: {
        id: 'ml.quoteandbind.paeditcoverages.pickYourCoverageLevel',
        defaultMessage: 'Pick your coverage level'
    }
});
